import React, { Component } from 'react'
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import Tool from '../../Components/ReportsComponents/Tool'

class ChildByClassroom extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
    const newData = []
    const { data } = this.props
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i += 1) {
        const item =
        { name: data[i].name, Capacidad: data[i].capacity, Activos: data[i].active_checkins_count }
        newData.push(item)
      }
      this.setState({ data: newData })
    }
  }

  componentWillReceiveProps(nextProps) {
    const newData = []
    const { data } = nextProps
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i += 1) {
        const item =
        { name: data[i].name, Capacidad: data[i].capacity, Activos: data[i].active_checkins_count }
        newData.push(item)
      }
      this.setState({ data: newData })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }


  render() {
    const { width, data } = this.state
    if (data[0]) {
      return (
        <ComposedChart
          width={width < 1024 ? 550 : 750}
          height={250}
          data={data}
          margin={{ top: 30, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={<Tool withoutCurrency withoutTotal />} />
          <Legend content={<CustomizedLegend />} />
          <Line type="monotone" dataKey="Capacidad" stroke="#ff7300" />
          <Bar dataKey="Activos" stackId="a" fill="#4A90E2" />
        </ComposedChart>
      )
    }
    return (
      <div />
    )
  }
}

export default ChildByClassroom



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/ChildByClassroom.jsx